const IconPepperArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.30847 3.70312C6.55233 3.70327 7.78992 4.55461 7.78992 6.19336C7.78991 7.22104 7.6256 8.09248 7.30554 8.83496L7.15515 9.18555H14.8661L14.5302 8.77539L11.9979 5.68848L12.2098 5.51367L15.2098 9.16113V9.47559L12.2098 13.1143L11.9979 12.9375L14.5302 9.86328L14.8671 9.45312H6.98035L6.90613 9.56641C6.76495 9.78256 6.60138 9.98746 6.42078 10.1719L6.23425 10.3496L6.2323 10.3516C5.22327 11.2681 3.6971 11.7624 1.66003 11.7998V11.5215C3.7919 11.4829 5.3713 10.9488 6.34851 9.82715L6.65613 9.47363L6.19226 9.41309C5.45707 9.31645 4.60806 9.05794 3.9491 8.55078C3.30013 8.05125 2.82705 7.30549 2.82703 6.19336C2.82703 4.55447 4.06451 3.70312 5.30847 3.70312ZM5.30847 3.98145C4.78457 3.98145 4.23418 4.15061 3.8114 4.51758C3.38308 4.88948 3.10242 5.45027 3.10242 6.19336C3.10245 7.49086 3.82151 8.23781 4.61902 8.65137C5.4025 9.05751 6.2742 9.15298 6.66003 9.1748L6.82117 9.18359L6.89636 9.04102C7.30861 8.25864 7.51354 7.30939 7.51355 6.19336C7.51355 5.45016 7.233 4.88948 6.80457 4.51758C6.38187 4.15069 5.83228 3.98151 5.30847 3.98145Z"
        fill="#736967"
        stroke="#736967"
        strokeWidth="0.501838"
      />
    </svg>
  );
};

export default IconPepperArrow;
